import { ShowButton } from "react-admin";

const DetailsButton = (props) => {
  return <ShowButton label="Details" {...props} />;
};

export { DetailsButton };
